import { useEffect, useState } from "react";

/** true zolang het scherm smaller is dan `px` (telefoon staand = 640). */
export function useSmal(px = 640) {
  const q = `(max-width: ${px}px)`;
  const [smal, setSmal] = useState(() => typeof window !== "undefined" && window.matchMedia(q).matches);
  useEffect(() => {
    const mq = window.matchMedia(q);
    const h = () => setSmal(mq.matches);
    h();
    mq.addEventListener("change", h);
    return () => mq.removeEventListener("change", h);
  }, [q]);
  return smal;
}

/** true op telefoon én tablet/iPad (smal scherm, aanraakscherm als hoofdinvoer of iPadOS); false op laptop/desktop. */
export function useGeenDesktop() {
  const smal = useSmal(1023);
  const [aanraak] = useState(() => typeof window !== "undefined" && (
    window.matchMedia("(pointer: coarse)").matches || (navigator.maxTouchPoints > 1 && /Macintosh|iPad/.test(navigator.userAgent))));
  return smal || aanraak;
}
